import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

export interface FxResultMonth {
    month: number;
    year: number;
    resultUsd: number;
    valoracionUsd: number;
    realizadaUsd: number;
    rateMovementPct: number;
}

export interface FxResultSummary {
    enabled: boolean;
    mode?: string;
    months: FxResultMonth[];
}

export interface FxResultEvent {
    type: 'revaluacion_diaria' | 'cambio_tasa' | 'conversion';
    group: 'valoracion' | 'realizada';
    accountId: string | null;
    accountName: string | null;
    balanceBs: number;
    rateOld: number;
    rateNew: number;
    resultUsd: number;
    resultUsdPrecise: number;
    timestamp: string;
}

export interface FxResultAccountLine {
    accountId: string;
    accountName: string | null;
    resultUsd: number;
}

export interface FxResultMonthDetail {
    enabled: boolean;
    month: number;
    year: number;
    byAccount: FxResultAccountLine[];
    events: FxResultEvent[];
}

@Injectable({
    providedIn: 'root',
})
export class FxResultsService {
    API_URL = environment.API_URL;

    constructor(private readonly http: HttpClient) {}

    // Resumen anual (una fila por mes) para las tarjetas del resumen de utilidad.
    getSummary$(year: number): Observable<{ data: FxResultSummary }> {
        return this.http.get<{ data: FxResultSummary }>(`${this.API_URL}/fx-results?year=${year}`);
    }

    // Detalle de un mes: líneas por cuenta + eventos para el desglose narrativo.
    getMonth$(month: number, year: number): Observable<{ data: FxResultMonthDetail }> {
        return this.http.get<{ data: FxResultMonthDetail }>(`${this.API_URL}/fx-results/month?month=${month}&year=${year}`);
    }
}
